import { useCheckFeatureGating } from '@nile/components/src/HOC/withPlanFeatureGating';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useContext } from 'react';
import { AppContext } from '@nile/components';

const chatFlagCheck = false;

const getHeaderContext = (customHeaders, userData) => {
  const agentProperties = JSON.parse(sessionStorage.getItem('agentProperties'));
  return {
    'asset-id': customHeaders?.AssetId || agentProperties?.AssetId,
    'asset-token': customHeaders?.AssetToken || agentProperties?.AssetToken,
    'app-acc': customHeaders?.AppAcc || agentProperties?.AppAcc,
    reqType: 'assetUser',
    userId: userData?.UserId || agentProperties?.UserId,
    userName: userData?.UserLoginName || agentProperties?.UserLoginName
  };
};

const useChatFeatureEnabled = () => {
  const flags = useFlags();
  const appContext = useContext(AppContext);
  const { user } = appContext;
  const isAgentVersionUpdated =
    user?.rmmAppProperties?.betaAgentBasedFeatures?.agentChat;
  const isChatAuthorised = useCheckFeatureGating('AGENT_CHAT')?.enabled;
  if (chatFlagCheck) {
    return isChatAuthorised && flags?.agentChatFe;
  }
  return isChatAuthorised && isAgentVersionUpdated;
};
export { getHeaderContext, useChatFeatureEnabled };
